import { ResponceDataType } from "../ErrorCode"

/**
 * 手動収集要求
 * @param deviceIndex 
 * @returns 
 */
export const PLCManualCollectionRequest = (deviceIndex: number): Promise<ResponceDataType> => {
  return new Promise((resolve, reject) => {
    fetch("api/PLCCommunicate/PLCManualCollection",{
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(deviceIndex),
    })
    .then((res) => res.json())
    .then((result: ResponceDataType) => resolve(result))
    .catch(reason => reject(reason));
  });
}

/**
 * 学習処理要求
 * @param deviceIndex 
 * @returns 
 */
export const PLCStudyRequest = (deviceIndex: number): Promise<ResponceDataType> => {
  return new Promise((resolve, reject) => {
    fetch("api/PLCCommunicate/PLCStudyRequest",{
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(deviceIndex),
    })
    .then((res) => res.json())
    .then((result: ResponceDataType) => resolve(result))
    .catch(reason => reject(reason));
  });
}

/**
 * 学習キャンセル処理要求
 * @param deviceIndex 
 * @returns 
 */
export const PLCStudyCancelRequest = (deviceIndex: number): Promise<ResponceDataType> => {
  return new Promise((resolve, reject) => {
    fetch("api/PLCCommunicate/PLCStudyCancelRequest",{
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(deviceIndex),
    })
    .then((res) => res.json())
    .then((result: ResponceDataType) => resolve(result))
    .catch(reason => reject(reason));
  });
}

/**
 * 再収集キャンセル処理要求
 * @param deviceIndex 
 * @returns 
 */
export const PLCRecollectionCancelRequest = (deviceIndex: number): Promise<ResponceDataType> => {
  return new Promise((resolve, reject) => {
    fetch("api/PLCCommunicate/PLCRecollectionCancelRequest",{
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(deviceIndex),
    })
    .then((res) => res.json())
    .then((result: ResponceDataType) => resolve(result))
    .catch(reason => reject(reason));
  });
}
